<template lang="pug">
.v-main-nav.main-nav(v-if="mainNav")
	//.main-nav__title(v-if="mainNav.title") {{mainNav.title}}
	nav.main-nav__menu
		ul.main-nav__list
			template(v-for="(item, index) in mainNav.items" :key="index")
				li.main-nav__item.flc
					img.main-nav__item-image(v-if="item.image" :src="item.image" alt="")
					.main-nav__item-main
						a.main-nav__item-link(:href="item.link") {{item.text}}
						ul.main-nav__item-list
							template(v-for="(itemLvl2, indexLvl2) in item.items" :key="indexLvl2")
								li.main-nav__item-lvl2.flc
									a.main-nav__item-link-lvl2(:href="itemLvl2.link") {{itemLvl2.text}}
									span.main-nav__separator
										span &nbsp;&nbsp;
										span |
										span &nbsp;&nbsp;

		.main-nav__bottom
			a.main-nav__tech.main-nav__item-link(
				v-if="ifTechLink"
				href="/technologists"
			) ДЛЯ ТЕХНОЛОГОВ

			a.main-nav__about.main-nav__item-link(
				v-if="mainNav.about"
				:href="mainNav.about.href"
			) {{mainNav.about.title}}
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import controller from "../scripts/controller/controller.js";

export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			mainNav: null
		};
	},

	mounted() {
		setTimeout(() => {
			controller.goToLink();
		}, 500)
	},

	computed: {
		ifTechLink: function() {
			console.log(window.location.host)
			return window.location.host.includes('.ru')
		}
	},

	methods: {
		dataSet(data) {
			this.mainNav = data;
		}
	}
};
</script>
